import {useRef, useState} from 'react'
import {PaymentCalenderPageContext} from '../contexts'
import PaymentCalenderHeader from '../sections/headers/PaymentCalenderHeader'
import PaymentCalenderContent from '../sections/calender/PaymentCalenderContent'
import PaymentListViewTable from '../sections/tables/PaymentListViewTable'
import {useGetCalendarEvents} from '../hooks/useGetCalendarEvents'
import useGetSuppliers from '../hooks/useGetSuppliers'
import useGetPaymentListData from '../hooks/useGetPaymentListData'

const PaymentCalender = () => {
  const calendarRef = useRef<any>(null)
  const [viewDateRange, setViewDateRange] = useState('')
  const [isCurrentDateIsInView, setIsCurrentDateIsInView] = useState(true)
  const [selectedDate, setSelectedDate] = useState<Date | null>(null)
  const [currentView, setCurrentView] = useState<'list' | 'calendar'>('list')

  // Hooks
  const {
    calendarEvents,
    filters,
    isLoading: isLoadingCalendarEvents,
    onSearch,
    onApplyCalendarFilters,
    resetCalendarFilters,
    updateCalendarMonth,
  } = useGetCalendarEvents()

  const {suppliersList, isLoadingSuppliers} = useGetSuppliers()

  // Payment List Data Hook
  const {
    paymentListData,
    filters :paymentListFilters,
    isLoadingPaymentListData,
    pagination: paymentListPagination,
    onPageChange: onPaymentListPageChange,
    onSortingChange: onPaymentListSortingChange,
    onApplyPaymentListFilters,
    resetPaymentListFilters,
  } = useGetPaymentListData()

  const contextValue = {
    // Calendar data
    calendarEvents,
    isLoadingCalendarEvents,
    calendarRef,

    // Filters
    filters,
    onSearch,

    // Suppliers dropdown
    suppliersList,
    isLoadingSuppliers,

    // Calendar navigation
    updateCalendarMonth,
    onApplyCalendarFilters,
    resetCalendarFilters,
    setViewDateRange,
    setIsCurrentDateIsInView,
    viewDateRange,
    isCurrentDateIsInView,

    // Modal state
    selectedDate,
    setSelectedDate,

    // List view state
    currentView,
    setCurrentView,

    // Payment List Data
    paymentListData,
    paymentListFilters,
    isLoadingPaymentListData,
    paymentListPagination,
    onPaymentListPageChange,
    onPaymentListSortingChange,
    onApplyPaymentListFilters,
    resetPaymentListFilters,
  }

  return (
    <PaymentCalenderPageContext.Provider value={contextValue}>
      <PaymentCalenderHeader />

      <div className='table-modes'>
        {/* Conditional rendering based on current view */}
        {currentView === 'list' ? <PaymentListViewTable /> : <PaymentCalenderContent />}
      </div>
    </PaymentCalenderPageContext.Provider>
  )
}

export default PaymentCalender
